export default {"src":"/_next/static/media/rtm-logo.42672acd.svg","height":32,"width":133,"blurWidth":0,"blurHeight":0};